import Vue from 'vue';

const state = {
	positionTemplates: [],
	positionTemplates_loading: false,
	positionTemplatesArchived: [],
	positionTemplatesArchived_loading: false,
	positionTemplatesArchived_loaded: false,
	globalPositionTemplates: [],
	globalPositionTemplates_loading: false,
	globalPositionTemplates_loaded: false
};

const getters = {
	positionTemplates: state => {
		return state.positionTemplates;
	},
	positionTemplateList: state => {
		return state.positionTemplates.map(pt => {
			let model = {
				id: pt.id,
				title: pt.title,
				description: pt.description,
				department: pt.department !== null ? pt.department.name : null
			};
			return model;
		});
	},
	positionTemplateArchivedList: state => {
		return state.positionTemplatesArchived.map(pt => {
			let model = {
				id: pt.id,
				title: pt.title,
				description: pt.description,
				department: pt.department !== null ? pt.department.name : null
			};
			return model;
		});
	},
	globalPositionTemplates: state => {
		return state.globalPositionTemplates;
	},
	globalPositionTemplatesInUse: state => {
		return [...new Set(state.positionTemplates
		.filter(x => x.globalPositionTemplateId != null)
		.map(x => x.globalPositionTemplateId))];
	}
};

const actions = {
	getById({ rootState }, id) {
		return new Promise((resolve, reject) => {
			Vue.axios
				.get(`/api/${rootState.tenantId}/positionTemplates/${id}`)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	},
	get({ commit, rootState }) {
		console.log('Retrieving Position Templates...');
		commit('GET_PENDING');
		return Vue.axios
			.get(`/api/${rootState.tenantId}/positionTemplates`)
			.then(response => {
				commit('GET_SUCCESS', response.data);
			})
			.catch(error => {
				commit('GET_FAILURE', error);
			});
	},
	getArchived({ commit, rootState }) {
		console.log('Retrieving Archived Position Templates...');
		commit('GET_PENDING');
		return Vue.axios
			.get(`/api/${rootState.tenantId}/positionTemplates/archived`)
			.then(response => {
				commit('GET_ARCHIVED_SUCCESS', response.data);
			})
			.catch(error => {
				commit('GET_ARCHIVED_FAILURE', error);
			});
	},
	add({ commit, dispatch, rootState }, positionTemplate) {
		console.log('Adding New Position Template...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/api/${rootState.tenantId}/positionTemplates`, positionTemplate)
				.then(resp => {
					dispatch('get');
					commit('ADD_SUCCESS', resp.data);
					resolve(resp.data);
				})
				.catch(err => {
					console.log('Error saving Position Template');
					console.log(err);
					reject(err);
				});
		});
	},
	edit({ commit, dispatch, rootState }, positionTemplate) {
		console.log('Updating Position Template...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/positionTemplates/${positionTemplate.id}`, positionTemplate)
				.then(resp => {
					dispatch('get');
					commit('EDIT_SUCCESS', resp.data);
					resolve(resp.data);
				})
				.catch(err => {
					console.log('Error updating Position Template');
					console.log(err);
					reject(err);
				});
		});
	},
	delete({ commit, dispatch, rootState }, positionTemplate) {
		console.log('Deleting Position Template...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.delete(`/api/${rootState.tenantId}/positionTemplates/${positionTemplate.id}`)
				.then(resp => {
					dispatch('get');
					dispatch('getArchived');
					commit('DELETE_SUCCESS', positionTemplate);
					resolve(true);
				})
				.catch(err => {
					console.log('Error deleting Position Template');
					console.log(err);
					reject(err);
				});
		});
	},
	archive({ commit, rootState }, id) {
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/api/${rootState.tenantId}/positionTemplates/${id}/archive`)
				.then(resp => {
					commit('ARCHIVE_SUCCESS', id);
					resolve(true);
				})
				.catch(err => {
					console.log('Error archiving Position Template');
					console.log(err);
					reject(err);
				});
		});
	},
	unarchive({ commit, rootState }, id) {
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/api/${rootState.tenantId}/positionTemplates/${id}/unarchive`)
				.then(resp => {
					commit('UNARCHIVE_SUCCESS', id);
					resolve(true);
				})
				.catch(err => {
					console.log('Error unarchiving Position Template');
					console.log(err);
					reject(err);
				});
		});
	},
	getGlobalTemplates({ commit }) {
		console.log('Retrieving Global Position Templates...');
		commit('GET_GLOBAL_PENDING');
		return Vue.axios
			.get(`/api/marketplace/globalPositionTemplates`)
			.then(response => {
				commit('GET_GLOBAL_SUCCESS', response.data);
			})
			.catch(error => {
				commit('GET_GLOBAL_FAILURE', error);
			});
	},
	getGlobalTemplateById({ rootState }, id) {
		return new Promise((resolve, reject) => {
			Vue.axios
				.get(`/api/marketplace/globalPositionTemplates/${id}`)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	},
	useGlobalTemplate({ rootState, dispatch }, template) {
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/api/${rootState.tenantId}/positionTemplates/useTemplate/${template.templateId}`, {
					title: template.title,
					department: template.department
				})
				.then(resp => {
					dispatch('get');
					dispatch('categories/get', null, { root: true });
					resolve(resp.data);
				})
				.catch(err => {
					console.log(err);
					reject(err);
				});
		});
	},
};

const mutations = {
	GET_PENDING(state) {
		state.positionTemplates_loading = true;
	},
	GET_GLOBAL_PENDING(state) {
		state.globalPositionTemplates_loading = true;
	},
	GET_SUCCESS(state, data) {
		state.positionTemplates_loading = false;
		state.positionTemplates = data;
	},
	GET_FAILURE(state, error) {
		state.positionTemplates_loading = false;
		console.log(error);
	},
	GET_ARCHIVED_SUCCESS(state, data) {
		state.positionTemplatesArchived_loading = false;
		state.positionTemplatesArchived_loaded = true;
		state.positionTemplatesArchived = data;
	},
	GET_ARCHIVED_FAILURE(state, error) {
		state.positionTemplatesArchived_loading = false;
		console.log(error);
	},
	GET_GLOBAL_SUCCESS(state, data) {
		state.globalPositionTemplates_loading = false;
		state.globalPositionTemplates_loaded = true;
		state.globalPositionTemplates = data;
	},
	GET_GLOBAL_FAILURE(state, error) {
		state.globalPositionTemplates_loading = false;
		console.log(error);
	},
	ADD_SUCCESS(state, data) {
		state.positionTemplates.push(data);
	},
	ARCHIVE_SUCCESS(state, positionTemplateId) {
		const index = state.positionTemplates.findIndex(x => x.id === positionTemplateId);

		if (index > -1) {
			const updated = state.positionTemplates[index];
			updated.isArchived = true;

			// Remove from active list
			state.positionTemplates.splice(index, 1);

			// Add to archived list
			state.positionTemplatesArchived.push(updated);
		}			
	},
	UNARCHIVE_SUCCESS(state, positionTemplateId) {
		const index = state.positionTemplatesArchived.findIndex(x => x.id === positionTemplateId);

		if (index > -1) {
			const updated = state.positionTemplatesArchived[index];
			updated.isArchived = false;

			// Remove from archived list
			state.positionTemplatesArchived.splice(index, 1);

			// Add to active list
			state.positionTemplates.push(updated);
		}			
	},
	EDIT_SUCCESS(state, data) {
		const index = state.positionTemplates.findIndex(x => x.id === data.id);
		if (index > -1)
			state.positionTemplates.splice(index, 1, data);
	},
	DELETE_SUCCESS(state, data) {
		let index = state.positionTemplates.indexOf(data);
		if (index > -1) {
			state.positionTemplates.splice(index, 1);
		} else {
			index = state.positionTemplatesArchived.indexOf(data);
			if (index > -1) {
				state.positionTemplatesArchived.splice(index, 1);
			}
		}
		
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
